import src from "IMAGE";
export default { src, width: 154, height: 141, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
